/* eslint-disable no-undef */
import Modal from 'components/modal';
import { delegate } from 'utils/delegate';
import { render } from 'utils/renderVue';
import { extractScripts } from 'utils/injectDom';

export async function fetchAndRenderModal(href) {
  const url = href.toString();

  const response = await fetch(url, { headers: { 'Accept': 'text/html' } });
  const html = await response.text();
  const dom = document.createElement('div');
  dom.innerHTML = html;
  renderModal(dom);
  supercast.trigger('pageload');
  supercast.trigger('modal-loaded');
}

export function renderModal(dom) {
  const container = document.querySelector('#modal-container');

  // We extract out scripts and attach them separately because scripts that are
  // attached as childen of another node are not executed. If we extract them out
  // and execute them one by one we can ensure that they are run.
  const scripts = extractScripts(dom);
  render(container, Modal, { content: dom.querySelector('.modal-content').innerHTML })
  scripts.forEach(script => document.body.appendChild(script));
}

delegate({
  selector: '.modal-link',
  eventName: 'click',
  handler: async function (e) {
    e.preventDefault();
    const link = e.target.closest('a');
    await fetchAndRenderModal(link.href);
    if (link.dataset.refreshOnClose) {
      document.querySelector('#modal-container').addEventListener("modalClose", () => {
        window.location.reload();
      });
    }
  }
})

delegate({
  selector: '.modal-form',
  eventName: 'ajax:success',
  handler: function (e) {
    e.preventDefault();
    renderModal(e.detail[0]);
  }
})
